import { useMutation } from "@tanstack/react-query";

import { AmplitudeApi } from "@/api/amplitude";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { useLocalLadyIdContext } from "@/context/local-lady-id-context/LocalLadyId.context";
import { useSendSignInForm } from "@/features/forms/sign-in-form/hooks";
import { InfoModalResDto } from "@/models/infoModalRes.dto";

import { FacebookApi } from "../api";
import { helpers } from "../helpers";

export const useFacebookLogin = () => {
  const localLadyId = useLocalLadyIdContext();
  const { mutate: sendSignInFormLoginFromFBLogin } = useSendSignInForm({
    isLoginFromFacebookLogin: true,
    ladyId: localLadyId,
  });
  const { mutate: sendSignInFormFromRegistration } = useSendSignInForm({
    isLoginFromRegistration: true,
    ladyId: localLadyId,
  });
  const { openModal } = useOpenModal();
  const openInformationModal = (dto: InfoModalResDto) => {
    openModal("INFORMATION_MODAL", { ...dto });
  };

  return useMutation(FacebookApi.login, {
    onSuccess: async (data) => {
      if (!data) return;

      if (helpers.isError(data)) {
        await AmplitudeApi.send({
          amplitude: "sign_up",
          signup_method: "facebook",
          error: true,
        });

        openInformationModal({ statusReg: "fail", message: data.ex });

        return;
      }

      if (helpers.isSuccessLogin(data)) {
        sendSignInFormLoginFromFBLogin({
          username: data.email,
          userpass: data.info,
        });

        return;
      }

      if (helpers.isSuccessRegistration(data)) {
        await AmplitudeApi.send({
          amplitude: "sign_up",
          signup_method: "facebook",
          error: false,
        });

        sendSignInFormFromRegistration({
          username: data.email,
          userpass: data.info,
        });

        return;
      }
    },
  });
};
